import { Messages } from './list'
import { MessageReply } from './reply'
import { MessageDetail } from './detail'

export { Messages, MessageDetail, MessageReply }



// WEBPACK FOOTER //
// ./src/components/messages/index.js